const initializedIds = new Set();

const ensureGtag = () => {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
};

export const initGoogleAnalytics = (measurementId) => {
  if (!measurementId || initializedIds.has(measurementId)) {
    return;
  }

  ensureGtag();
  window.gtag('js', new Date());

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.gtag('config', measurementId, { send_page_view: false });
  initializedIds.add(measurementId);
};

export const trackPageView = (measurementId, pagePath, pageTitle) => {
  if (!measurementId) return;

  initGoogleAnalytics(measurementId);
  window.gtag('event', 'page_view', {
    send_to: measurementId,
    page_path: pagePath,
    page_title: pageTitle,
  });
};

export const trackEvent = (measurementId, eventName, params = {}) => {
  if (!measurementId) return;

  initGoogleAnalytics(measurementId);
  window.gtag('event', eventName, {
    send_to: measurementId,
    ...params,
  });
};
